import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { getRecords } from '../api/stoApi';
import { IRecordGetResponse } from '../models';
import { generalStore } from '../stores/GeneralStore';

export const useAssetRecords = (
  triggerReload: boolean,
  options: {
    assetId: string;
    limit: number;
    offset: number;
  },
) => {
  const [records, setRecords] = useState<
    | {
        year: string;
        records: IRecordGetResponse[];
      }[]
    | null
  >(null);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        if (!options.assetId) return;
        const recordsForAsset = await getRecords(options.assetId, options.offset, options.limit);
        const recordsByYear = recordsForAsset.data.data.data.reduce((acc, record) => {
          const year = new Date(record.createdAt).getFullYear();
          if (!acc[year]) {
            acc[year] = [];
          }
          acc[year].push(record);
          return acc;
        }, {} as Record<string, IRecordGetResponse[]>);

        // Put every createdAt per year in a new array, arrays are sorted descending by year
        const recordsByYearSorted = Object.keys(recordsByYear)
          .sort((a, b) => Number(b) - Number(a))
          .map((year) => {
            return {
              year,
              records: recordsByYear[year].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
            };
          });
        setRecords(recordsByYearSorted);
        setTotalRecords(recordsForAsset.data.data.total);
      } catch (error: any) {
        console.log(error);
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    if (!options.assetId) return;
    load();
  }, [triggerReload]);

  return { records, totalRecords };
};
